import { createFileRoute } from '@tanstack/react-router'

import GuestOrderResultPage from '@/views/orders/pages/guest.orders-result.page'

export const Route = createFileRoute('/_layout/guest/orders/result')({
  component: GuestOrderResultPage,
})
